import Emitter from "_actions/emitter";
import { EXCLUDED_PERMISSION_NAMES } from "_constants";
import { userConstants } from "_constants";
let user = null;
let token = null;
try {
  token = localStorage.getItem("access_token");
  user = JSON.parse(localStorage.getItem("user"));
} catch (error) {
  token = null;
  user = null;
}

const _initialState = token
  ? {
    loggedIn: true,
    user,
    currentLang: localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en",
    LoginFailed: false,
  }
  : {
    loggedIn: false,
    LoginFailed: false,
    currentLang: localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en",
  };

const initialState = {
  ..._initialState,
  authLoading: !token, // Token varsa loading false, yoksa true
  wallet: {
    balance: 0,
    bonus: 0,
  },
  permissions: {},
  permissionsAll: [],
};

// Bu SettingName değerleri permissions ve permissionsAll listelerinden çıkarılır
 

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_SUCCESS:
      localStorage.setItem("user", JSON.stringify(action.user));

      try {
        const _mUsr = localStorage.getItem("myMenuClickHistoriesUser");
        if (action.user._id !== _mUsr) {
          localStorage.removeItem("myMenuClickHistories");
          Emitter.emit("UPDATE_FAV_LIST", null);
        }
      } catch (error) { }

      return {
        ...state,
        loggedIn: true,
        user: action.user,
        wallet: {
          ...state.wallet,
          balance: action.user?.Balance,
        },
        authLoading: false,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        LoginFailed: true,
        loggedIn: false,
        authLoading: false,
      };
    case userConstants.LOGOUT:
      localStorage.removeItem("access_token");
      localStorage.removeItem("expires_in");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      // Home sayfası scroll reset flag'ini temizle
      sessionStorage.removeItem("homePageLoaded");
      // Hatırlanan login bilgilerini temizle
      localStorage.removeItem("rememberedUsername");
      localStorage.removeItem("rememberedPassword");

      return {
        ...state,
        loggedIn: false,
        user: null,
      };
    case userConstants.UPDATE_USER:
      return {
        ...state,
        loggedIn: true,
        user: {
          ...user,
          ...action.user,
        },
        wallet: {
          ...state.wallet,
          balance: action.user?.Balance,
        },
      };

    case userConstants.UPDATE_LANG:
      localStorage.setItem("lang", action.data);
      return {
        ...state,
        currentLang: action.data,
      };
    case userConstants.UPDATE_WALLET:
      return {
        ...state,
        wallet: {
          ...state.wallet,
          ...action.data,
        },
      };
      case userConstants.UPDATE_PERMISSIONS:
        // Önce EXCLUDED_PERMISSION_NAMES ile filtrele
        const filteredData = action.data.filter(
          (item) => !EXCLUDED_PERMISSION_NAMES.includes(item.SettingName)
        );
        // Filtrelenmiş listeyi kullan
        let _value = {};
        for (let index = 0; index < filteredData.length; index++) {
          _value[filteredData[index].SettingName] = filteredData[index];
        }
        return {
          ...state,
          permissions: _value,
          permissionsAll: filteredData,
        };
    default:
      return state;
  }
}


